'use strict';

define(function (require, exports, module) {
    require('@babel/polyfill/dist/polyfill.min.js');

    var searchNames = require('./searchNamesConfig');

    var getViewport = function getViewport() {
        var viewPortWidth = null;
        var viewPortHeight = null;

        if (typeof window.innerWidth !== 'undefined') {
            viewPortWidth = window.innerWidth;
            viewPortHeight = window.innerHeight;
        } else if (
            typeof document.documentElement !== 'undefined' &&
            typeof document.documentElement.clientWidth !== 'undefined' &&
            document.documentElement.clientWidth !== 0
        ) {
            viewPortWidth = document.documentElement.clientWidth;
            viewPortHeight = document.documentElement.clientHeight;
        } else {
            viewPortWidth = document.getElementsByTagName('body')[0]
                .clientWidth;
            viewPortHeight = document.getElementsByTagName('body')[0]
                .clientHeight;
        }

        return [viewPortWidth, viewPortHeight];
    };

    var viewport = getViewport();
    var viewportWidth = viewport && viewport.length && viewport[0];
    var headerEl = document.querySelector('.header');
    var headerNav = headerEl.querySelector('.header__navigation') || {};
    var mobileNav = headerEl.querySelector('.header__mobile-nav');
    var mobileNavIcon = headerEl.querySelector('.header__hamburger');
    var secondaryNav =
        headerNav.querySelector('.header__nav-items--secondary') || {}; // Search

    var search =
        viewportWidth > 1023
            ? headerEl.querySelector('.header__search')
            : mobileNav.querySelector('.header__search');
    var searchHandler = search.querySelector('.search__handler');
    var searchClose = search.querySelector('.search__close');
    var searchInput = search.querySelector('.header__search-bar');
    var suggestions = search.querySelector('.search__suggestions'); // const searchSeeAll = search.querySelector('.search__see-all');
    // const contextUrlPrefix = window.pageMeta && window.pageMeta['context-url-prefix'] ? window.pageMeta['context-url-prefix'] : '/milb';

    var masterList;

    if (search) {
        searchHandler.addEventListener('click', function (e) {
            search.classList.add('open');
            mobileNav.classList.remove('open');
            mobileNavIcon.classList.remove('open');
            secondaryNav.classList.add('expand');
            searchInput.value = '';
            searchInput.focus();
            e.stopPropagation();
        });
        searchClose.addEventListener('click', function () {
            search.classList.remove('open');
            searchInput.value = '';
            suggestions.innerHTML = '';
            mobileNav.style.height = '';
            secondaryNav.classList.remove('expand'); // searchSeeAll.style.visibility = 'hidden';
        });
        searchInput.addEventListener('click', function (e) {
            e.stopPropagation();
        });

        // handle tabindex issues (particularly in iOS)
        var tabFields = [];
        searchInput.addEventListener('focus', function () {
            tabFields = [];
            var fields = document.querySelectorAll('input, select');
            // store the original tabIndex and set to -1
            for (var i = 0; i < fields.length; i++) {
                var field = fields[i];
                if (field) {
                    var fieldInfo = field.fieldInfo;
                    if (field.hasAttribute('tabindex')) {
                        fieldInfo.originalIndex = field.tabIndex;
                    }
                    tabFields.push(fieldInfo);
                    field.tabIndex = -1;
                }
            }
        });

        searchInput.addEventListener('blur', function () {
            if (tabFields.length) {
                // restore the original tabIndex
                tabFields.forEach(function (fieldObj) {
                    if (fieldObj.originalIndex) {
                        fieldObj.field.tabIndex = fieldObj.originalIndex;
                    } else {
                        fieldObj.field.removeAttribute('tabindex');
                    }
                });
            }
        });
    }

    document.addEventListener('click', function () {
        search.classList.remove('open');
        searchInput.value = '';
        suggestions.innerHTML = '';
        secondaryNav.classList.remove('expand'); // searchSeeAll.style.visibility = 'hidden';
    });
    mobileNavIcon.addEventListener('click', function () {
        // search close logic
        search.classList.remove('open');
        searchInput.value = '';
        suggestions.innerHTML = '';
        mobileNav.style.height = '';
        suggestions.style.width = '';
    });

    function findMatches(wordToMatch, list) {
        // store item IDs in a set to prevent duplicate matches
        var matches = new Set();
        var itemReturn = list.filter(function (item) {
            if (matches.has(item.id)) {
                return false;
            }

            var regex = new RegExp(wordToMatch, 'gi');
            return item.primary.match(regex) && matches.add(item.id);
        });
        return itemReturn;
    }

    var fetchedTypes = [];

    function displayMatches(array, type) {
        masterList = masterList.concat(array);
        fetchedTypes.push(type);

        if (fetchedTypes.length < 3) {
            return;
        }

        var value = searchInput.value;
        var matchArray = findMatches(value, masterList);
        var html = matchArray
            .map(function (item) {
                var regex = new RegExp(value, 'gi');
                var itemName = item.primary.replace(
                    regex,
                    '<span class="hl">'.concat(value, '</span>')
                );
                var avatar;
                var url;
                var playerInfo =
                    item.secondary && item.tertiary
                        ? '<div class="search__result-secondary">'
                            .concat(item.secondary, ', (')
                            .concat(item.tertiary, ')</div>')
                        : '';

                if (item.type === 'player') {
                    avatar = ''
                        .concat(
                            window.server_path.cms_data_cname.client,
                            '/images/'
                        )
                        .concat(item.id, '/generic/180x270/')
                        .concat(item.id, '.jpg');
                    url = 'http://www.milb.com/player/index.jsp?sid=milb&player_id='.concat(
                        item.id
                    );
                } else if (item.type === 'league') {
                    avatar = 'https://www.mlbstatic.com/team-logos/league-on-light/'
                        .concat(item.id, '.svg');
                    url = 'http://www.milb.com/index.jsp?sid=l'.concat(item.id);
                } else if (item.type === 'team') {
                    var slug = window.MilbUtils.teamIdToSlugMap[item.id];
                    avatar = 'https://www.mlbstatic.com/team-logos/'.concat(
                        item.id,
                        '.svg'
                    );
                    url = ''
                        .concat(window.server_path.server, '/')
                        .concat(slug);
                }

                return '\n                <a href="'
                    .concat(
                        url,
                        '" class="search__result-link">\n                    <span class="search__result-img">\n                        <img src="'
                    )
                    .concat(
                        avatar,
                        '" onerror="this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\'">\n                    </span>\n                    <span class="search__result-item">\n                        <div class="search__result-primary">'
                    )
                    .concat(itemName, '</div>\n                        ')
                    .concat(
                        playerInfo,
                        '\n                    </span>\n                </a>\n            '
                    );
            })
            .join('');
        suggestions.innerHTML = html;
        suggestions.classList.add('has-suggestions'); // const seeAllMessage = `See all News for <span>${value}</span>`;
        // searchSeeAll.innerHTML = seeAllMessage;
        // searchSeeAll.setAttribute('href', `${contextUrlPrefix}/news/search?q=${value}&type=article&pageId=search&page=1`);
        // const suggestionsHeight = suggestions.offsetHeight;
        // set max height on suggestions for mobile

        var documentHtmlClasslist =
            document.querySelector('html') &&
            document.querySelector('html').classList;

        if (
            documentHtmlClasslist.contains('device-phone') ||
            documentHtmlClasslist.contains('device-tablet')
        ) {
            var headerHeight = headerNav.clientHeight;
            var searchInputHeight = searchInput.clientHeight;
            var heightDiff =
                headerHeight +
                searchInputHeight +
                window.outerHeight -
                window.innerHeight;
            suggestions.style.maxHeight = 'calc(100vh - '.concat(
                heightDiff,
                'px)'
            );
            mobileNav.style.height = 'calc(100vh - '.concat(
                headerHeight + window.outerHeight - window.innerHeight,
                'px)'
            );
        }

        var fnAdjustResultPlacements;

        if (value === '') {
            suggestions.innerHTML = '';
            suggestions.classList.remove('has-suggestions');
            mobileNav.style.height = ''; //searchSeeAll.innerHTML = '';
            //searchSeeAll.style.visibility = 'hidden';
        }

        fnAdjustResultPlacements = function adjustResultPlacements(x) {
            if (x.matches) {
                // If media query matches aka mobile
                if (suggestions.innerHTML === '') {
                    // searchSeeAll.style.top = '38px';
                    searchClose.style.display = 'none';
                    mobileNav.style.height = '';
                } else {
                    // searchSeeAll.style.top = suggestionsHeight + 40 + 'px';
                    // searchSeeAll.style.visibility = 'visible';
                    suggestions.style.visibility = 'visible';
                    searchClose.style.display = 'block';
                }
            } else {
                if (suggestions.innerHTML === '') {
                    // searchSeeAll.style.top = '42px';
                } else {
                    // searchSeeAll.style.top = suggestionsHeight + 27 + 'px';
                    // searchSeeAll.style.visibility = 'visible';
                }
            }
        };

        var x = window.matchMedia('(max-width: 1024px)');
        fnAdjustResultPlacements(x);
        x.addListener(fnAdjustResultPlacements);
    }

    function dataCall(searchString) {
        if (searchString.length < 3) {
            suggestions.innerHTML = '';
            mobileNav.style.height = ''; // searchSeeAll.innerHTML = '';
            // searchSeeAll.style.visibility = 'hidden';

            return;
        }

        masterList = [];
        var bracket = Array.from(searchNames.bracket);
        var searchedName =
            searchString.charAt(0).toUpperCase() + searchString.slice(1);
        var searchedNameAfter = bracket.findIndex(function (name) {
            return name.toLowerCase() > searchedName.toLowerCase();
        });
        var index =
            searchedNameAfter >= 0 ? searchedNameAfter : bracket.length - 1;
        var firstName = bracket[index - 1].toLowerCase();
        var lastName = bracket[index].toLowerCase();
        var leaguesEndpoint =
            'https://statsapi.mlb.com/api/v1/league?leagueIds=109,110,111,112,113,116,117,118,120,121,122,123,124,125,126,127,128,130';
        var teamsEndpoint =
            'https://statsapi.mlb.com/api/v1/teams?sportIds=11,12,13,14,15,5442,16';
        var playersEndpoint = 'https://lookup-service-prod.mlb.com/json/named.search_autocomplete_milb.bam?start_name=%27'
            .concat(firstName, '%27&end_name=%27')
            .concat(lastName, '%27');
        fetch(leaguesEndpoint)
            .then(function (blob) {
                return blob.json();
            })
            .then(function (data) {
                var type = 'league';
                var leagues = data.leagues.map(function (league) {
                    return {
                        primary: league.name,
                        id: league.id,
                        type: type
                    };
                });
                displayMatches(leagues, type);
            });
        fetch(teamsEndpoint)
            .then(function (blob) {
                return blob.json();
            })
            .then(function (data) {
                var type = 'team';
                var teams = data.teams.map(function (team) {
                    return {
                        primary: team.name,
                        id: team.id,
                        type: type
                    };
                });
                displayMatches(teams, type);
            });
        fetch(playersEndpoint)
            .then(function (blob) {
                return blob.json();
            })
            .then(function (data) {
                var type = 'player';
                var players = data.search_autocomplete_milb.queryResults.row.map(
                    function (player) {
                        return {
                            primary: player.n,
                            secondary: player.t_short,
                            tertiary: player.pt,
                            id: player.p,
                            type: type
                        };
                    }
                );
                displayMatches(players, type);
            });
    }

    if (search) {
        var timeout;
        searchInput.addEventListener('input', function () {
            clearTimeout(timeout);
            timeout = setTimeout(function () {
                dataCall(searchInput.value);
            }, 100);
        });
        search.addEventListener('keyup', function (e) {
            if (e.keyCode === 13) {
                e.preventDefault();
            } else if (e.keyCode === 27) {
                search.classList.remove('open');
                searchInput.value = '';
                suggestions.innerHTML = '';
                mobileNav.style.height = '';
                secondaryNav.classList.remove('expand'); // searchSeeAll.style.visibility = 'hidden';
            }
        });
    }
});
